module.exports = __webpack_public_path__ + "static/media/student-add--typing.afff62c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/rostery/src/student-add--typing.png
// module id = 635
// module chunks = 0